import { CSSProperties, useContext, useState } from "react";
import "./GamifiedQuiz.css";
import { extractGradientColors } from "../../../../general";
interface propType {
  options: string[] | [] | any;
  checked?: string[];
  selectedStyle?: ExtendedCSSProperties;
  style?: ExtendedCSSProperties;
  onChange?: (e: { target: { value: string; checked: boolean } }) => void;
}

type ExtendedCSSProperties = CSSProperties & {
  borderColor?: string;
  accentColor?: string;
  color?: string;
};

interface propTypeTwo {
  selectedStyle?: ExtendedCSSProperties;
  options: string[] | [] | any;
  checked?: string[];
  style?: ExtendedCSSProperties;
  onChange?: (e: { target: { value: string; checked: boolean } }) => void;
}

const CheckBoxImg = ({ backgroundColor = "#6525B3", color = "white" }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
  >
    <path
      d="M19 3H5C3.89 3 3 3.9 3 5V19C3 20.1 3.89 21 5 21H19C20.11 21 21 20.1 21 19V5C21 3.9 20.11 3 19 3ZM10 17L5 12L6.41 10.59L10 14.17L17.59 6.58L19 8L10 17Z"
      fill={backgroundColor}
    />
  </svg>
);

const CheckBox = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
  >
    <path
      d="M19 5V19H5V5H19ZM19 3H5C3.9 3 3 3.9 3 5V19C3 20.1 3.9 21 5 21H19C20.1 21 21 20.1 21 19V5C21 3.9 20.1 3 19 3Z"
      fill="#B9B9B9"
    />
  </svg>
);

export const MultiChoice = ({
  options,
  checked,
  selectedStyle = { color: "#6525B3" },
  style,
  onChange = () => {},
}: propType) => {
  const onClick = (option: number) => {
    setCheckedState((prevState) => {
      if (prevState.includes(options[option])) {
        let ans = prevState.filter((item) => item !== options[option]);
        return ans;
      } else {
        let ans = [...prevState, options[option]];
        return ans;
      }
    });
  };

  const [checkedState, setCheckedState] = useState(checked || []);

  let accentColor = selectedStyle?.accentColor || "#6525B3";
  if (accentColor.includes("gradient")) {
    accentColor = extractGradientColors(accentColor);
  }
  if (selectedStyle?.color && selectedStyle?.color.includes("gradient")) {
    selectedStyle.color = extractGradientColors(selectedStyle.color);
  }
  if (selectedStyle?.borderColor && selectedStyle?.borderColor.includes("gradient")) {
    selectedStyle.borderColor = extractGradientColors(selectedStyle.borderColor);
  }
  if (selectedStyle?.accentColor && selectedStyle?.accentColor.includes("gradient")) {
    selectedStyle.accentColor = extractGradientColors(selectedStyle.accentColor);
  }
  
  return (
    <div className="q_multi_choice_box_G">
      {options.map((option: string, id: number) => (
        <div
          style={{
            ...style,
            borderColor:
              (checkedState?.includes(option) && selectedStyle?.borderColor) ||
              style?.borderColor,
          }}
          className="q_mult_choice_option_G"
          key={id}
          onClick={() => {
            onClick(id);
            onChange({
              target: {
                value: option,
                checked: !checkedState.includes(option),
              },
            });
          }}
        >
          {checkedState?.includes(option) ? (
            <CheckBoxImg backgroundColor={accentColor} />
          ) : (
            <CheckBox />
          )}
          <p
            className="label-input-cont-multi_G"
            style={checkedState?.includes(option) ? selectedStyle : style}
          >
            {option}
          </p>
        </div>
      ))}
    </div>
  );
};

export const MultiChoiceTwo = ({
  options,
  checked,
  style,
  selectedStyle,
  onChange = () => {},
}: propTypeTwo) => {
  const onClick = (option: number) => {
    setCheckedState((prevState) => {
      if (prevState.includes(options[option])) {
        let ans = prevState.filter((item) => item !== options[option]);
        return ans;
      } else {
        let ans = [...prevState, options[option]];
        return ans;
      }
    });
  };

  const [checkedState, setCheckedState] = useState(checked || []);

  return (
    <div className="q_multi_choice_box_2_G">
      {options.map((option: string, id: number) => (
        <div
          style={{
            ...(checkedState?.includes(option) ? {...selectedStyle, color: "white"} : style),
          }}
          className={
            checkedState?.includes(option)
              ? "q_mult_choice_option_2_select_G"
              : "q_mult_choice_option_2_G"
          }
          key={id}
          onClick={() => {
            onClick(id);
            onChange({
              target: {
                value: option,
                checked: !checkedState.includes(option),
              },
            });
          }}
        >
          {option}
        </div>
      ))}
    </div>
  );
};
